// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AyurvedMed Healthcare Styles */

/* Animation keyframes */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideInLeft {
    from {
        opacity: 0;
        transform: translateX(-30px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes float {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px);
    }
}

.animate-fade-in-up {
    animation: fadeInUp 0.6s ease-out forwards;
}

.animate-fade-in {
    animation: fadeIn 0.8s ease-out forwards;
}

.animate-slide-in-left {
    animation: slideInLeft 0.6s ease-out forwards;
}

.animate-float {
    animation: float 3s ease-in-out infinite;
}

/* Stagger animation delays */
.stagger-1 { animation-delay: 0.1s; }
.stagger-2 { animation-delay: 0.2s; }
.stagger-3 { animation-delay: 0.3s; }
.stagger-4 { animation-delay: 0.4s; }
.stagger-5 { animation-delay: 0.5s; }
.stagger-6 { animation-delay: 0.6s; }

/* Glass morphism effect */
.glass {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
}

/* Card hover effects */
.card-hover {
    transition: transform 0.4s ease, box-shadow 0.4s ease;
}

.card-hover:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px -15px rgba(45, 74, 62, 0.15);
}

/* Button styles */
.btn-primary {
    background-color: #2D4A3E;
    color: white;
    padding: 1rem 2rem;
    border-radius: 9999px;
    font-weight: 500;
    transition: background-color 0.3s ease, transform 0.2s ease, box-shadow 0.3s ease;
    box-shadow: 0 4px 15px -3px rgba(45, 74, 62, 0.3);
}

.btn-primary:hover {
    background-color: #1e3329;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px -5px rgba(45, 74, 62, 0.4);
}

.btn-secondary {
    background-color: transparent;
    color: #2D4A3E;
    padding: 1rem 2rem;
    border-radius: 9999px;
    font-weight: 500;
    border: 2px solid #2D4A3E;
    transition: background-color 0.3s ease, color 0.3s ease;
}

.btn-secondary:hover {
    background-color: #2D4A3E;
    color: white;
}

.btn-accent {
    background-color: #C67D63;
    color: white;
    padding: 1rem 2rem;
    border-radius: 9999px;
    font-weight: 500;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.btn-accent:hover {
    background-color: #a86850;
    transform: translateY(-2px);
}

/* Section styles */
.section-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1.5rem;
}

@media (min-width: 768px) {
    .section-container {
        padding: 0 3rem;
    }
}

.section-padding {
    padding-top: 5rem;
    padding-bottom: 5rem;
}

@media (min-width: 768px) {
    .section-padding {
        padding-top: 8rem;
        padding-bottom: 8rem;
    }
}

/* Typography */
.heading-1 {
    font-family: 'Playfair Display', serif;
    font-size: 2.5rem;
    font-weight: 500;
    line-height: 1.1;
    letter-spacing: -0.02em;
}

@media (min-width: 768px) {
    .heading-1 {
        font-size: 4rem;
    }
}

@media (min-width: 1024px) {
    .heading-1 {
        font-size: 5rem;
    }
}

.heading-2 {
    font-family: 'Playfair Display', serif;
    font-size: 2rem;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.01em;
}

@media (min-width: 768px) {
    .heading-2 {
        font-size: 3rem;
    }
}

.heading-3 {
    font-family: 'Playfair Display', serif;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.3;
}

@media (min-width: 768px) {
    .heading-3 {
        font-size: 1.875rem;
    }
}

.body-large {
    font-size: 1.125rem;
    line-height: 1.75;
}

@media (min-width: 768px) {
    .body-large {
        font-size: 1.25rem;
    }
}

.caption {
    font-size: 0.875rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    font-weight: 600;
    color: #C67D63;
}

/* Hero background overlay */
.hero-overlay {
    background: linear-gradient(180deg, rgba(45, 74, 62, 0.05) 0%, rgba(249, 248, 246, 1) 100%);
}

/* Stars for reviews */
.star-filled {
    color: #C67D63;
}

/* Leaf decoration */
.leaf-decoration {
    position: absolute;
    opacity: 0.08;
    pointer-events: none;
}

/* Article card image */
.article-image {
    aspect-ratio: 16/9;
    object-fit: cover;
    transition: transform 0.5s ease;
}

.article-card:hover .article-image {
    transform: scale(1.05);
}

/* Mobile menu */
.mobile-menu {
    transform: translateX(100%);
    transition: transform 0.3s ease;
}

.mobile-menu.open {
    transform: translateX(0);
}

/* WhatsApp floating button */
.whatsapp-float {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    z-index: 50;
    width: 60px;
    height: 60px;
    background-color: #25D366;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.whatsapp-float:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 25px rgba(37, 211, 102, 0.5);
}

/* Prose styles for article content */
.prose h2 {
    font-family: 'Playfair Display', serif;
    font-size: 1.75rem;
    font-weight: 500;
    color: #2D4A3E;
    margin-top: 2rem;
    margin-bottom: 1rem;
}

.prose h3 {
    font-family: 'Playfair Display', serif;
    font-size: 1.375rem;
    font-weight: 500;
    color: #2D4A3E;
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;
}

.prose p {
    margin-bottom: 1rem;
    line-height: 1.75;
    color: #4A4A4A;
}

.prose ul, .prose ol {
    margin-bottom: 1rem;
    padding-left: 1.5rem;
}

.prose li {
    margin-bottom: 0.5rem;
    line-height: 1.6;
    color: #4A4A4A;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,wBAAwB;AACxB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA,6BAA6B;AAC7B,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;;AAEpC,0BAA0B;AAC1B;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA,uBAAuB;AACvB;IACI,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,iFAAiF;IACjF,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,iDAAiD;AACrD;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,uDAAuD;AAC3D;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA,eAAe;AACf;IACI,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,2FAA2F;AAC/F;;AAEA,sBAAsB;AACtB;IACI,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;AACxB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8CAA8C;IAC9C,qDAAqD;AACzD;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA,qCAAqC;AACrC;IACI,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":["/* AyurvedMed Healthcare Styles */\n\n/* Animation keyframes */\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes slideInLeft {\n    from {\n        opacity: 0;\n        transform: translateX(-30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes float {\n    0%, 100% {\n        transform: translateY(0);\n    }\n    50% {\n        transform: translateY(-10px);\n    }\n}\n\n.animate-fade-in-up {\n    animation: fadeInUp 0.6s ease-out forwards;\n}\n\n.animate-fade-in {\n    animation: fadeIn 0.8s ease-out forwards;\n}\n\n.animate-slide-in-left {\n    animation: slideInLeft 0.6s ease-out forwards;\n}\n\n.animate-float {\n    animation: float 3s ease-in-out infinite;\n}\n\n/* Stagger animation delays */\n.stagger-1 { animation-delay: 0.1s; }\n.stagger-2 { animation-delay: 0.2s; }\n.stagger-3 { animation-delay: 0.3s; }\n.stagger-4 { animation-delay: 0.4s; }\n.stagger-5 { animation-delay: 0.5s; }\n.stagger-6 { animation-delay: 0.6s; }\n\n/* Glass morphism effect */\n.glass {\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n}\n\n/* Card hover effects */\n.card-hover {\n    transition: transform 0.4s ease, box-shadow 0.4s ease;\n}\n\n.card-hover:hover {\n    transform: translateY(-8px);\n    box-shadow: 0 20px 40px -15px rgba(45, 74, 62, 0.15);\n}\n\n/* Button styles */\n.btn-primary {\n    background-color: #2D4A3E;\n    color: white;\n    padding: 1rem 2rem;\n    border-radius: 9999px;\n    font-weight: 500;\n    transition: background-color 0.3s ease, transform 0.2s ease, box-shadow 0.3s ease;\n    box-shadow: 0 4px 15px -3px rgba(45, 74, 62, 0.3);\n}\n\n.btn-primary:hover {\n    background-color: #1e3329;\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px -5px rgba(45, 74, 62, 0.4);\n}\n\n.btn-secondary {\n    background-color: transparent;\n    color: #2D4A3E;\n    padding: 1rem 2rem;\n    border-radius: 9999px;\n    font-weight: 500;\n    border: 2px solid #2D4A3E;\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.btn-secondary:hover {\n    background-color: #2D4A3E;\n    color: white;\n}\n\n.btn-accent {\n    background-color: #C67D63;\n    color: white;\n    padding: 1rem 2rem;\n    border-radius: 9999px;\n    font-weight: 500;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.btn-accent:hover {\n    background-color: #a86850;\n    transform: translateY(-2px);\n}\n\n/* Section styles */\n.section-container {\n    max-width: 1280px;\n    margin: 0 auto;\n    padding: 0 1.5rem;\n}\n\n@media (min-width: 768px) {\n    .section-container {\n        padding: 0 3rem;\n    }\n}\n\n.section-padding {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n}\n\n@media (min-width: 768px) {\n    .section-padding {\n        padding-top: 8rem;\n        padding-bottom: 8rem;\n    }\n}\n\n/* Typography */\n.heading-1 {\n    font-family: 'Playfair Display', serif;\n    font-size: 2.5rem;\n    font-weight: 500;\n    line-height: 1.1;\n    letter-spacing: -0.02em;\n}\n\n@media (min-width: 768px) {\n    .heading-1 {\n        font-size: 4rem;\n    }\n}\n\n@media (min-width: 1024px) {\n    .heading-1 {\n        font-size: 5rem;\n    }\n}\n\n.heading-2 {\n    font-family: 'Playfair Display', serif;\n    font-size: 2rem;\n    font-weight: 500;\n    line-height: 1.2;\n    letter-spacing: -0.01em;\n}\n\n@media (min-width: 768px) {\n    .heading-2 {\n        font-size: 3rem;\n    }\n}\n\n.heading-3 {\n    font-family: 'Playfair Display', serif;\n    font-size: 1.5rem;\n    font-weight: 500;\n    line-height: 1.3;\n}\n\n@media (min-width: 768px) {\n    .heading-3 {\n        font-size: 1.875rem;\n    }\n}\n\n.body-large {\n    font-size: 1.125rem;\n    line-height: 1.75;\n}\n\n@media (min-width: 768px) {\n    .body-large {\n        font-size: 1.25rem;\n    }\n}\n\n.caption {\n    font-size: 0.875rem;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    font-weight: 600;\n    color: #C67D63;\n}\n\n/* Hero background overlay */\n.hero-overlay {\n    background: linear-gradient(180deg, rgba(45, 74, 62, 0.05) 0%, rgba(249, 248, 246, 1) 100%);\n}\n\n/* Stars for reviews */\n.star-filled {\n    color: #C67D63;\n}\n\n/* Leaf decoration */\n.leaf-decoration {\n    position: absolute;\n    opacity: 0.08;\n    pointer-events: none;\n}\n\n/* Article card image */\n.article-image {\n    aspect-ratio: 16/9;\n    object-fit: cover;\n    transition: transform 0.5s ease;\n}\n\n.article-card:hover .article-image {\n    transform: scale(1.05);\n}\n\n/* Mobile menu */\n.mobile-menu {\n    transform: translateX(100%);\n    transition: transform 0.3s ease;\n}\n\n.mobile-menu.open {\n    transform: translateX(0);\n}\n\n/* WhatsApp floating button */\n.whatsapp-float {\n    position: fixed;\n    bottom: 2rem;\n    right: 2rem;\n    z-index: 50;\n    width: 60px;\n    height: 60px;\n    background-color: #25D366;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.whatsapp-float:hover {\n    transform: scale(1.1);\n    box-shadow: 0 6px 25px rgba(37, 211, 102, 0.5);\n}\n\n/* Prose styles for article content */\n.prose h2 {\n    font-family: 'Playfair Display', serif;\n    font-size: 1.75rem;\n    font-weight: 500;\n    color: #2D4A3E;\n    margin-top: 2rem;\n    margin-bottom: 1rem;\n}\n\n.prose h3 {\n    font-family: 'Playfair Display', serif;\n    font-size: 1.375rem;\n    font-weight: 500;\n    color: #2D4A3E;\n    margin-top: 1.5rem;\n    margin-bottom: 0.75rem;\n}\n\n.prose p {\n    margin-bottom: 1rem;\n    line-height: 1.75;\n    color: #4A4A4A;\n}\n\n.prose ul, .prose ol {\n    margin-bottom: 1rem;\n    padding-left: 1.5rem;\n}\n\n.prose li {\n    margin-bottom: 0.5rem;\n    line-height: 1.6;\n    color: #4A4A4A;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
